import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconMacbook: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconMacbook"><Path d="M3.5 3.5H20.5V17.5H3.5V3.5Z" stroke="currentColor" strokeLinecap="square"/><Path d="M1.5 17.5H22.5V20.5H1.5V17.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconMacbook;
